export const calculateTimestampForPeriod = (periodInHours) => {
    const millisecondsInHour = 3600000; // 60 * 60 * 1000
    return Math.trunc(Date.now() - periodInHours * millisecondsInHour);
};
export const formatTruncatedDuration = (delta) => {
    let remainingDelta = delta;
    const days = Math.floor(remainingDelta / 86400);
    remainingDelta -= days * 86400;
    const hours = Math.floor(remainingDelta / 3600) % 24;
    remainingDelta -= hours * 3600;
    const minutes = Math.floor(remainingDelta / 60) % 60;
    remainingDelta -= minutes * 60;
    const daysStr = days > 0 ? `${days}d` : '0d';
    const hoursStr = hours > 0 ? `${hours}h` : '0h';
    const minsStr = minutes > 0 ? `${minutes}m` : '0m';
    return days > 10 ? `${daysStr}:${hoursStr}`.trim() : `${daysStr}:${hoursStr}:${minsStr}`.trim();
};
export const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};
//# sourceMappingURL=date.js.map